import { Body1, Body2, BrandGraphic, Display2, XStack, YStack } from "@medbillai/ui";
import { OnboardingScreen } from "../../components/OnboardingScreen";
import { copy, landing } from "./copy";
const HEADLINE = `${copy.save.headline.before}${copy.save.headline.highlight}${copy.save.headline.after}`;
const BODY = `${copy.save.subhead.before}${copy.save.subhead.highlight}`;
export function RoutingSaveValidation({
  onContinue
}: {
  onContinue: () => void;
}) {
  return <OnboardingScreen tone="dark" data-sentry-element="OnboardingScreen" data-sentry-component="RoutingSaveValidation" data-sentry-source-file="RoutingSaveValidation.tsx">
      <OnboardingScreen.Nav data-sentry-element="OnboardingScreen.Nav" data-sentry-source-file="RoutingSaveValidation.tsx" />
      <OnboardingScreen.Content data-sentry-element="OnboardingScreen.Content" data-sentry-source-file="RoutingSaveValidation.tsx">
        <YStack gap="$sp1.5" paddingBottom="$sp8" testID="intake-routing.save-validation" data-sentry-element="YStack" data-sentry-source-file="RoutingSaveValidation.tsx">
          <Display2 color="$textInverseBrand" data-sentry-element="Display2" data-sentry-source-file="RoutingSaveValidation.tsx">{HEADLINE}</Display2>
          <Body1 color="$textInverseSubtle" data-sentry-element="Body1" data-sentry-source-file="RoutingSaveValidation.tsx">{BODY}</Body1>
        </YStack>
        <XStack justifyContent="center" marginVertical="auto" data-sentry-element="XStack" data-sentry-source-file="RoutingSaveValidation.tsx">
          <BrandGraphic type="coverage" indicator="check" size="$si14" data-sentry-element="BrandGraphic" data-sentry-source-file="RoutingSaveValidation.tsx" />
        </XStack>
      </OnboardingScreen.Content>
      <OnboardingScreen.Footer data-sentry-element="OnboardingScreen.Footer" data-sentry-source-file="RoutingSaveValidation.tsx">
        <Body2 textAlign="center" color="$textInverseMuted" data-sentry-element="Body2" data-sentry-source-file="RoutingSaveValidation.tsx">
          {landing.trust}
        </Body2>
        <OnboardingScreen.PrimaryAction testID="intake-routing.save-validation-continue" variant="brand" onPress={onContinue} data-sentry-element="OnboardingScreen.PrimaryAction" data-sentry-source-file="RoutingSaveValidation.tsx">
          {copy.save.cta}
        </OnboardingScreen.PrimaryAction>
      </OnboardingScreen.Footer>
    </OnboardingScreen>;
}